/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.vars.palette.action.selected,
      border: `1px solid ${theme.vars.palette.divider}`,
      borderRadius: 8,
      gap: 2,
      padding: 2,
      '& .MuiToggleButtonGroup-grouped': {
        border: 0,
        margin: 0,
        '&:first-of-type': {
          borderRadius: 6,
        },
        '&:not(:first-of-type)': {
          borderLeft: 0,
          borderRadius: 6,
        },
      },
    }),
  },
};
